import { Component, OnInit, ViewChild } from "@angular/core";
import { Meta, Title } from "@angular/platform-browser";
import { ActivatedRoute, Router } from "@angular/router";
import { NgbDropdown } from "@ng-bootstrap/ng-bootstrap";
import { HrUserAuthenticationService } from "src/app/core/storage/authentication-hruser.service";
import { StorageService } from "src/app/core/storage/storage.service";
import { HrregistrationComponent } from "src/app/pages/hr_registration/hr_registration.component";
import { ShowregisterloginService } from "src/app/services/showregisterlogin.service";
declare var $: any;
@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.css"],
  providers: [HrregistrationComponent],
})
export class HeaderComponent implements OnInit {
  public type_user: any;
  public firstName: any;
  public displayName: string = "";
  public isLoggedIn: boolean = false;
  public dashboardUrl: string = "";
  public isShow = true;
  title = "#1 HRMKING - Best HR and Payroll Management Software";
  myDropDown: any;
  constructor(
    private hrUserAuthenticationService: HrUserAuthenticationService,
    public hrregistrationComponent: HrregistrationComponent,
    private route: ActivatedRoute,
    private router: Router,
    private hr_registrationS: ShowregisterloginService,
    private storageService: StorageService,
    private titleMeta: Title,
    private meta: Meta
  ) { }

  over(drop: NgbDropdown) {
    drop.open();
  }
  out(drop: NgbDropdown) {
    drop.close();
  }
  ngOnInit() {
    this.checkLoginStatus();

    ///////////////////////meta tag/////////////////

    this.meta.addTags([
      { charset: "UTF-8" },
      { name: "viewport", content: "width=device-width, initial-scale=1" },
      { name: "date", content: "2023-01-01", scheme: "YYYY-MM-DD" },
      {
        name: "keywords",
        content:
          "HR Software, Payroll Software, Attendance Management, Salary Slip, Payroll Management, accounts, invoice, CRM, Projects",
      },
      { name: "author", content: "Srmak Technological System Private Limited" },
      { name: "robots", content: "index, follow" },
    ]);

    ////////////////////////title meta///////////////////////

    this.titleMeta.setTitle(this.title);

    /////////////////////////////////////////////////
  }

  checkLoginStatus() {
    const currentUser = this.storageService.secureStorage.getItem("currentUser");
    const currentUserLogin = this.storageService.secureStorage.getItem("currentUserLogin");
    const userType = this.storageService.secureStorage.getItem("user_type");
    const typeUser = this.storageService.secureStorage.getItem("user_type");
    const userId = this.storageService.secureStorage.getItem("userId") ||
      this.storageService.secureStorage.getItem("adminId") ||
      this.storageService.secureStorage.getItem("hrUserId");

    this.isLoggedIn = !!(currentUser || currentUserLogin || userType || typeUser || userId);
    this.type_user = userType || typeUser;
    console.log("type_user", this.type_user);
    console.log("isLoggedIn", this.isLoggedIn);

    const fName = this.storageService.secureStorage.getItem("firstName") ||
      this.storageService.secureStorage.getItem("first_name");
    const lName = this.storageService.secureStorage.getItem("lastName") ||
      this.storageService.secureStorage.getItem("last_name");
    const fullName = this.storageService.secureStorage.getItem("name");
    const userName = this.storageService.secureStorage.getItem("username");
    const clientName = this.storageService.secureStorage.getItem("ClientfirstName");
    const roleName = this.storageService.secureStorage.getItem("roleadminfirstName") ||
      this.storageService.secureStorage.getItem("roleHRfirstName") ||
      this.storageService.secureStorage.getItem("roleManagerfirstName") ||
      this.storageService.secureStorage.getItem("roleFinancefirstName") ||
      this.storageService.secureStorage.getItem("roleReceptionistfirstName");

    if (fName) {
      this.firstName = fName;
      this.displayName = lName ? `${fName} ${lName}` : fName;
    } else if (fullName) {
      this.firstName = fullName;
      this.displayName = fullName;
    } else if (userName) {
      this.firstName = userName;
      this.displayName = userName;
    } else if (clientName) {
      this.firstName = clientName;
      this.displayName = clientName;
    } else if (roleName) {
      this.firstName = roleName;
      this.displayName = roleName;
    } else if (this.type_user) {
      this.firstName = this.type_user.charAt(0).toUpperCase() + this.type_user.slice(1);
      this.displayName = this.firstName;
    } else {
      this.firstName = "User";
      this.displayName = "User";
    }

    if (this.type_user === "employee" || currentUser === "EmployeeLogin") {
      this.dashboardUrl = "/layout/dashboard/employee";
    } else if (this.type_user === "client" || currentUser === "ClientLogin") {
      this.dashboardUrl = "/layout/dashboard/client";
    } else if (this.type_user === "affiliate" || currentUser === "AffiliateLogin") {
      this.dashboardUrl = "/layout/dashboard/affiliate";
    } else if (this.type_user === "mainadmin" || currentUser === "MainAdminLogin") {
      this.dashboardUrl = "/layout/dashboard/mainadmin";
    } else if (this.type_user === "hrUser" || currentUserLogin === "HrUserLogin") {
      this.dashboardUrl = "/products";
    } else if (this.isLoggedIn) {
      this.dashboardUrl = "/layout/dashboard/admin";
    }

    this.isShow = !this.isLoggedIn;
  }

  showDropdown() {
    // Optional click handler
  }

  logout() {
    try {
      this.hrUserAuthenticationService.logout();
    } catch (e) { }
    try {
      this.storageService.secureStorage.clear();
      sessionStorage.clear();
      localStorage.clear();
    } catch (e) { }
    this.isLoggedIn = false;
    this.isShow = true;
    window.location.replace("");
  }

  visible() {
    this.isShow = !this.isLoggedIn;
  }

  showPage(value) {
    if (value === "register") {
      this.hr_registrationS.showPage("signUp");
      this.router.navigate(["/register"], {
        queryParams: {
          signUp: "signUp",
        },
      });
    } else if (value === "login") {
      this.hr_registrationS.showPage("signIn");
      this.router.navigate(["/register"], {
        queryParams: {
          signUp: "signIn",
        },
      });
    }
  }

  getFreeTrial() {
    if (this.isLoggedIn) {
      this.router.navigate(["/checkouts"]);
    } else {
      this.router.navigate(["/register"]);
    }
  }
}
